export const globalColors = {
  primaryColor: '#2864AC',
  secondaryColor: '#7ec141',
  disabledColor: '#cdcdcd',
  phoneOutlineColor: '#666666',
  lightGreyColor: '#e6e6e6',
  overallBackground: '#f4f4f4',
  whiteColor: '#fff',
  accentColor: '#5182BB'
};
